module.exports = __webpack_public_path__ + "static/images/share_bg.e479296.png";